// Quick guide — the Big 4 verbs (essere, stare, avere, fare), present tense. The
// most-used verbs in Italian, all irregular, worth knowing cold. Hand-drawn
// paper style. Pairs with the verb articles — read once, refer here forever.
import { speakButtonHTML } from "../lib/audio.js";

const PRONOUNS = ["io", "tu", "lui / lei", "noi", "voi", "loro"];
const VERBS = [
  { inf: "essere", en: "to be — identity, traits", forms: ["sono", "sei", "è", "siamo", "siete", "sono"], color: "text-emerald-700" },
  { inf: "stare", en: "to be — state, health, place", forms: ["sto", "stai", "sta", "stiamo", "state", "stanno"], color: "text-sky-700" },
  { inf: "avere", en: "to have", forms: ["ho", "hai", "ha", "abbiamo", "avete", "hanno"], color: "text-amber-700" },
  { inf: "fare", en: "to do / make", forms: ["faccio", "fai", "fa", "facciamo", "fate", "fanno"], color: "text-rose-600" },
];

function colHTML(v) {
  const rows = v.forms
    .map(
      (f, i) => `
      <div class="flex items-baseline justify-between gap-2 py-0.5 border-b border-dashed border-amber-300/40 last:border-0">
        <span class="text-sage-400 text-sm" style="font-family:Inter,sans-serif">${PRONOUNS[i]}</span>
        <span class="text-sage-800 font-semibold">${f}${speakButtonHTML(f)}</span>
      </div>`
    )
    .join("");
  return `
    <div class="flex-1 min-w-[8.5rem]">
      <h3 class="${v.color} text-2xl sketch-underline inline-block leading-none">${v.inf}</h3>
      <p class="text-xs text-sage-500 mb-2 mt-1" style="font-family:Inter,sans-serif">${v.en}</p>
      ${rows}
    </div>`;
}

export function bigFourVerbsView(app) {
  app.innerHTML = `
    <section class="max-w-3xl mx-auto fade-in">
      <h2 class="text-4xl font-script text-sage-800 mb-1">The Big 4 Verbs ⭐</h2>
      <p class="text-sage-600 mb-4" style="font-family:Inter,sans-serif">The four you'll reach for constantly — all irregular, so learn them as whole shapes. Present tense.</p>
      <div class="paper sketch-box p-5 sm:p-7 font-hand text-lg">
        <div class="flex flex-wrap gap-5">${VERBS.map(colHTML).join("")}</div>
        <div class="mt-5 pt-4 border-t border-dashed border-amber-300/50 text-base">
          <p class="text-amber-700 text-xl sketch-underline inline-block mb-1">essere vs stare</p>
          <p class="text-sage-700">Both can render “to be”. <b class="text-emerald-700">essere</b> = who/what something <i>is</i> (identity, origin, lasting traits, feelings). <b class="text-sky-700">stare</b> = how you <i>are</i> right now — health and set phrases. <span class="text-sage-500">sono alto</span> (I'm tall) vs <span class="text-sage-500">sto male</span> (I feel unwell) · <span class="text-sage-500">come stai?</span> (how are you?). And watch out: many English “be” phrases use <b class="text-amber-700">avere</b> — <span class="text-sage-500">ho fame</span> (I'm hungry), <span class="text-sage-500">ho vent'anni</span> (I'm 20).</p>
        </div>
      </div>
      <p class="text-xs text-sage-400 mt-4" style="font-family:Inter,sans-serif">Want the full conjugation across every tense? Open any of these from the Verb Index.</p>
    </section>`;
  window.scrollTo({ top: 0, behavior: "smooth" });
}
